import {defineMessages} from 'react-intl';

export const headerMessages = defineMessages({
  apis: {
    id: 'docsShell.navigation.apis',
    description: 'Link to APIs and SDKs',
    defaultMessage: 'APIs & SDKs',
  },
  dashboard: {
    id: 'docsShell.navigation.dashboard',
    description: 'Link to Stripe dashboard',
    defaultMessage: 'Dashboard',
  },
  signIn: {
    id: 'docsShell.navigation.signIn',
    description: 'Link to signing into an account',
    defaultMessage: 'Sign in',
  },
  createAccount: {
    id: 'docsShell.navigation.createAccount',
    description: 'Link to creating an account',
    defaultMessage: 'Create account',
  },
  support: {
    id: 'docsShell.navigation.supportLink',
    description: 'Link to the Stripe support website',
    defaultMessage: 'Support',
  },
  home: {
    id: 'docsShell.navigation.home',
    description: 'Label for docs home',
    defaultMessage: 'Home',
  },
});
